import { Theme } from "../../../../components/constants"

export default {
    header: {
        marginTop: "50px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        rowGap: "18px",
    },

    headerText: {
        fontSize: "18px"
    },

    buttonsContainer: {
        display: "flex",
        columnGap: "20px",
        justifyContent: "center",
        marginTop: "40px",
    },

    button: {
        padding: "8px 20px"
    },

    buttonLight: {
        fontWeight: "700",
        fontSize: "14px",
        lineHeight: "17px",
        color: Theme.PRIMARY
    },

    buttonWithOutBorder: {
        display: "flex",
        columnGap: "40px",
        justifyContent: "center",
        marginTop: "60px",
        flexWrap: "wrap",
        rowGap: "30px",
    }
}